import queryString from 'query-string';
import { VIDEO_TYPES } from './metadata';

const DEFAULT_PAGE_SIZE = 50;
export function seasonSettingsToQueryString(showId, settings = {}) {
    const { selectedSeasons, videoType, includePassportVideos, selectedRegions } = settings;

    let params = {
        'show-id': showId,
        'page-size': DEFAULT_PAGE_SIZE
    };

    if (selectedRegions) {
        params['country'] = selectedRegions.map(({ value }) => value).join(',');
    }

    if ([VIDEO_TYPES.CLIP, VIDEO_TYPES.PREVIEW].includes(videoType)) {
        params['type'] = videoType;
    }
    if (videoType === VIDEO_TYPES.EPISODE) {
        params['parent-type'] = 'episode';
        params['type'] = VIDEO_TYPES.EPISODE;
    }
    if (selectedSeasons) {
        const seasonIds = selectedSeasons
            .map((season) => season.value)
            .filter((value) => value);
        if (seasonIds.length) {
            params['seasonId'] = seasonIds;
        }
    }

    if (includePassportVideos) {
        params.available = 'station_members';
    } else {
        params.available = 'public';
    }
    const encodedParams = queryString.stringify(params);

    return `?${encodedParams}`;
}
